import { extend } from 'flarum/extend';
import app from 'flarum/app';
import UserControls from 'flarum/utils/UserControls';
import Button from 'flarum/components/Button';
import Badge from 'flarum/components/Badge';
import User from 'flarum/models/User';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';

import SuspendUserModal from './components/SuspendUserModal';
import UserSuspendedNotification from './components/UserSuspendedNotification';
import UserUnsuspendedNotification from './components/UserUnsuspendedNotification';
import checkForSuspension from './checkForSuspension';
import Discussion from 'flarum/common/models/Discussion';
import Model from 'flarum/common/Model';
import PostControls from 'flarum/forum/utils/PostControls';

export { default as extend } from './extend';

app.initializers.add('flarum-suspend', () => {
  app.notificationComponents.userSuspended = UserSuspendedNotification;
  app.notificationComponents.userUnsuspended = UserUnsuspendedNotification;
  Discussion.prototype.essence = Model.attribute('essence');
  Discussion.prototype.canEssence = Model.attribute('canEssence');

  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    let isEssence = discussion.essence();
    let user = discussion.user();
    //加精
    if (discussion.canEssence()) {
      items.add(
        'suspendUser',
        Button.component(
          {
            icon: 'fas jh',
            onclick: () => {
              isEssence = !isEssence;
              discussion.save({ essence: isEssence }).then(()=>{AlertUtil.onSuccess(app, app.translator.trans(`dl-index.forum.permissions.success_${!isEssence ? 'not_essence_label' : 'essence_label'}`));app.discussions.refresh();});
              
            },
          },
          app.translator.trans(
            discussion.essence() ? 'dl_discussion_controller.forum.set_not_essence' : 'dl_discussion_controller.forum.set_essence'
          )
        )
      );
    }
    if (app.session.user != user && user.canSuspend() && user.groups().length == 0) {
      items.add(
        'suspend',
        <Button icon="fas fa-ban" onclick={() => app.modal.show(SuspendUserModal, { user })}>
          {app.translator.trans('flarum-suspend.forum.user_controls.suspend_button')}
        </Button>
      );
    }
  });

  extend(PostControls, 'moderationControls', function (items, post) {
    let discussion = post.discussion();
    let isEssence = discussion.essence();
    let user = post.user();
    //加精
    if (post.number() == 1 && discussion.canEssence()) {
      items.add(
        'suspendUser',
        Button.component(
          {
            icon: 'fas jh',
            onclick: () => {
              isEssence = !isEssence;
              discussion.save({ essence: isEssence }).then(AlertUtil.onSuccess(app, app.translator.trans(`dl-index.forum.permissions.success_${!isEssence ? 'not_essence_label' : 'essence_label'}`)));
            },
          },
          app.translator.trans(
            discussion.essence() ? 'dl_discussion_controller.forum.set_not_essence' : 'dl_discussion_controller.forum.set_essence'
          )
        )
      );
    }
    if (app.session.user != post.user() && user.canSuspend() && post.user().groups().length == 0) {
      items.add(
        'suspend',
        <Button icon="fas fa-ban" onclick={() => app.modal.show(SuspendUserModal, { user })}>
          {app.translator.trans('flarum-suspend.forum.user_controls.suspend_button')}
        </Button>
      );
    }
  });

  extend(UserControls, 'moderationControls', (items, user) => {
    if (user.canSuspend()) {
      items.add(
        'suspend',
        <Button icon="fas fa-ban" onclick={() => app.modal.show(SuspendUserModal, { user })}>
          {app.translator.trans('flarum-suspend.forum.user_controls.suspend_button')}
        </Button>
      );
    }
  });

  extend(User.prototype, 'badges', function (items) {
    const until = this.suspendedUntil();

    if (new Date() < until) {
      items.add(
        'suspended',
        <Badge icon="fas fa-ban" type="suspended" label={app.translator.trans('flarum-suspend.forum.user_badge.suspended_tooltip')} />,
        100
      );
    }
  });

  checkForSuspension();
});

// Expose compat API
import suspendCompat from './compat';
import { compat } from '@flarum/core/forum';

Object.assign(compat, suspendCompat);
